<template>
  <div class="s-history" v-if="data">
    <div class="message-header">
      <p class="message-header__time">{{ time }}</p>
      <p class="message-header__author">
        {{ formatHtml(data.created_by_full_name) }}
      </p>
    </div>
    <p class="message-text" v-html="$sanitize(historyText)"></p>
  </div>
</template>

<script>
import { mixin } from '@/utils/mixins';

export default {
  mixins: [mixin],
  props: {
    data: Object,
    module: String
  },
  data() {
    return {
      isFullText: false,
      visibleTextHelp: false
    };
  },
  computed: {
    time() {
      return this.data.date_created.split(' ')[1];
    },
    historyText() {
      const text = this.data.display_value_text || this.data.after_value_string;
      return this.formatHtml(text);
    }
  }
};
</script>

<style lang="scss" scoped>
.s-history {
  margin-bottom: 16px;

  .message-header {
    gap: 8px;
    display: flex;
    align-self: center;

    &__time {
      color: $grey64;
      font-size: 15px;
      line-height: 24px;
    }

    &__author {
      margin: 0;
      color: $grey64;
      font-size: 15px;
      line-height: 24px;
      text-decoration: none;
    }
  }

  .message-text {
    font-size: 15px;
    line-height: 24px;

    ::v-deep b {
      font-weight: normal;
      font-family: 'Roboto Medium';
    }
  }
}
</style>
